import type { IconProps } from './types/types';

const IncreaseIcon = (props: IconProps) => {
  const { fill = 'currentColor', ...rest } = props;
  const svgProps = { fill, ...rest };
  return (
    <svg
      width="11"
      height="11"
      viewBox="0 0 11 11"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M9.875 1.125L1.125 9.875M9.875 1.125H2M9.875 1.125V9"
        stroke="#00CC76"
        strokeWidth="1.3125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default IncreaseIcon;
